import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import BiCheckBox from '../controls/BiCheckBox';
import { format } from "date-fns";
import { Sec2Str, Str2Sec } from '../../helpers/timeHelper';
import './BiDataGrid.css';
import BiTextBox from '../controls/BiTextBox';
import BiButton from '../controls/BiButton';
import BiComboBox from '../controls/BiComboBox';
import useFetch from '../../helpers/useFetch';
import BiDatePicker from '../controls/BiDatePicker';
import numeral from 'numeral';
import { httpGet } from '../../helpers/httpHelper';
import BiTimePicker from '../controls/BiTimePicker';
import BiTimeDTPicker from '../controls/BiTimeDTPicker';
import yesno from 'yesno-dialog'
import BiColorPicker from '../controls/BiColorPicker';
import BiHelp from '../controls/BiHelp';
import { SessionContext } from '../../../context/SessionProvider';
import BiAutoCB from '../controls/BiAutoCB';
import authService from '../../api-authorization/AuthorizeService'

const BiDataGrid = ({
    columns,
    items: dataItems,
    mainKey,

    addUrl,
    removeUrl,
    urlParams,

    toolbar,

    name,
    reload,
    onDataChanged,
    onSelectionChanged: osc,
    onSelectedItemChanged: osic,
    onRemove,
    onAdd,

    selectedItem: si,

    helpMainKey: hmk,
    dividerOn,
    footer,
    readOnly,
    colWidth,
    disabled
}) => {
    const { toastError } = useContext(SessionContext)
    //const [scrollDiv, setScrollDiv] = useState(null);
    const scrollDiv = useRef(null);



    const [loaded, setLoaded] = useState(false);
    const [rel, setRel] = useState(false);

    const [dataColumns, setDataColumns] = useState(null);
    const [columnsWidth, setColumnsWidth] = useState(null);

    //izbrana vrstica
    const [selectedItem, setSelectedItem] = useState(null);

    //vse za sort kolon
    const [sort, setSort] = useState("");
    const [sortWay, setSortWay] = useState(null);
    const [sortType, setSortType] = useState(null);

    //ko se spremeni item
    const onSelectedItemChanged = (e) => {


        const { value } = e.target;
        if (value != selectedItem[e.target.name]) {

            if (osic) {
                osic(e, name, mainKey, selectedItem);
            }
        }
    }

    //ko se spremeni item
    const onSelectedItemChangedCB = (e, item) => {


        setSelectedItem(item);


        const { value } = e.target;
        if (value != item[e.target.name]) {

            if (osic) {
                osic(e, name, mainKey, item);
            }
        }


    }

    const addClick = () => {




        httpGet(addUrl, urlParams, (response) => {
            if (response.success) {
                if (onAdd != null) {
                    onAdd(name, mainKey, response.data);
                }
            } else {
                toastError(response.message);
            }
        }, authService);
    }
    const removeClick = () => {
        if (selectedItem != null) {


            const yes = yesno({
                labelYes: "Da",
                labelNo: "Ne",
                bodyText: "Ali želite izbrisati označeno vrstico?"
            });

            yes.then((val) => {
                if (val) {
                    httpGet(removeUrl, { id: selectedItem[mainKey] }, (response) => {
                        if (response.success) {
                            if (onRemove != null) {
                                onRemove(name, mainKey, selectedItem);
                            }
                            setSelectedItem(null);
                        } else {
                            toastError(response.message);
                        }
                    }, authService);
                }
            }
                );

        }
    }

    //klik na vrstico + izbor
    const onSelectionChanged = (e) => {

        setSelectedItem(e);


        if (osc) {
            osc(e);
        }
    }

    //ko se spremnijo podatki tabele
    useEffect(() => {
        if (onDataChanged != null && dataItems != null) {
            onDataChanged({
                target: { name: name, value: dataItems }
            });
        }
    }, [dataItems]);

    //ko se spremnijo podatki tabele
    useEffect(() => {
        if (columnsWidth == null || colWidth==true) {
            var cols = [];
            columns.forEach(c => {
                cols.push(c.width);
            });
            setColumnsWidth(cols);
        }

        setDataColumns(columns);
    }, [columns]);

    useEffect(() => {
        setSelectedItem(si);



    }, [si]);


    //varianta nalganja preko items
    useEffect(() => {
        //setItems(items);
        setLoaded(true);
        setRel(false);
    }, [dataItems]);




    useEffect(() => {
        setRel(reload);
    }, [reload]);

    let resColIndex = null
    let x = 0;
    let wi = 0;
    const onMouseDown = (e, index) => {

        resColIndex = index;
        x = e.clientX;
        wi = columnsWidth[resColIndex];

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);

        e.stopPropagation();
    }
    const onMouseMove = (e) => {

        const dx = e.clientX - x;

        let wixx = ((parseInt(wi.replace("px", "")) + dx)) + "px";

        let nDel = [...columnsWidth];
        nDel[resColIndex] = wixx;

        setColumnsWidth(nDel);

        e.stopPropagation();
    }
    const onMouseUp = (e) => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mousemove', onMouseUp);
        e.stopPropagation();

    }

    const sortBy = (key, type) => {

        setSort(key);
        setSortType(type)
        if (sortWay == true) {
            setSortWay(false);
        } else {
            setSortWay(true);
        }
    }

    const renderHeader = () => {
        if (dataColumns == null) {
            return null;
        }
        return (

            <thead>

                <tr >
                    {dataColumns.map((col, index) =>
                        <th
                            key={col.key + "-" + mainKey + "-" + index}
                            style={{
                                ...(col.align != null ? { textAlign: col.align } : {}),
                                ...(((col.help == true) && hmk != null) ? { paddingRight: "25px" } : {})
                            }}
                        >
                            <div onClick={() => sortBy(col.key, col.type)} style={{ ...(col.labelStyle != undefined ? col.labelStyle.style : {}) }}>
                                {col.label}
                                {sort == col.key ?
                                    sortWay ? <i className="fas fa-caret-up biDataGridSortArrow"></i> : <i className="fas fa-caret-down biDataGridSortArrow"></i>
                                    : ""
                                }

                            </div>

                            {col.width.indexOf("px") > -1 &&
                                <div className="resizer" onMouseDown={(e) => onMouseDown(e, index)}></div>
                            }


                            {(col.help == true) &&
                                <BiHelp grid={true} helpMainKey={hmk} helpKey={col.key}></BiHelp>
                            }
                        </th>
                    )}
                </tr>
            </thead>
        );
    };

    const renderFooter = () => {
        if (dataColumns == null) {
            return null;
        }
        return (

            <tfoot>

                <tr >
                    <td colSpan={dataColumns.length} >aaaa</td>

                </tr>
            </tfoot>
        );
    };

    const renderColDef = () => {
        if (dataColumns == null) {
            return null;
        }

        return (
            <colgroup>

                {dataColumns.map((col, key) => {
                    return (
                        <col key={col.key + "-col-" + key} style={{ width: columnsWidth[key] }} />
                    );
                })}

            </colgroup >

        );
    };

    const sortString = (a, b) => {
        return (a[sort] + "").localeCompare(b[sort] + "")
    }
    const sortDecimal = (a, b) => {
        return (a[sort]) > (b[sort]) ? -1 : 1;
    }
    const sortCheckBox = (a, b) => {
        return (a[sort] + "").localeCompare(b[sort] + "")
    }
    const sortDate = (a, b) => {
        return new Date(a[sort]) - new Date(b[sort]) > 0 ? 1 : -1;
    }
    const sortTime = (a, b) => {
        return a[sort] - b[sort] > 0 ? 1 : -1;
    }
    const sortTimeDT = (a, b) => {
        return new Date(a[sort]) - new Date(b[sort]) > 0 ? 1 : -1;
    }
    const sortComboBox = (a, b) => {
        return (a[sort].naziv + "").localeCompare(b[sort].naziv + "")
    }
    const sortColor = (a, b) => {
        return (a[sort] + "").localeCompare(b[sort] + "")
    }

    const renderItems = () => {
        if (dataItems == null) {
            return null;
        }

        if (sort != null && sort != "") {
            if (sortWay) {
                switch (sortType) {
                    case "string": dataItems.sort((a, b) => sortString(a, b)); break;
                    case "template": dataItems.sort((a, b) => sortString(a, b)); break;
                    case "decimal": dataItems.sort((a, b) => sortDecimal(a, b)); break;
                    case "checkBox": dataItems.sort((a, b) => sortCheckBox(a, b)); break;
                    case "date": dataItems.sort((a, b) => sortDate(a, b)); break;
                    case "dateTime": dataItems.sort((a, b) => sortDate(a, b)); break;
                    case "time": dataItems.sort((a, b) => sortTime(a, b)); break;
                    case "timeDT": dataItems.sort((a, b) => sortTimeDT(a, b)); break;
                    case "comboBox": dataItems.sort((a, b) => sortComboBox(a, b)); break;
                    case "color": dataItems.sort((a, b) => sortColor(a, b)); break;
                }
            } else {
                switch (sortType) {
                    case "string": dataItems.sort((a, b) => sortString(b, a)); break;
                    case "template": dataItems.sort((a, b) => sortString(b, a)); break;
                    case "decimal": dataItems.sort((a, b) => sortDecimal(b, a)); break;
                    case "checkBox": dataItems.sort((a, b) => sortCheckBox(b, a)); break;
                    case "date": dataItems.sort((a, b) => sortDate(b, a)); break;
                    case "dateTime": dataItems.sort((a, b) => sortDate(b, a)); break;
                    case "time": dataItems.sort((a, b) => sortTime(b, a)); break;
                    case "timeDT": dataItems.sort((a, b) => sortTimeDT(b, a)); break;
                    case "comboBox": dataItems.sort((a, b) => sortComboBox(b, a)); break;
                    case "color": dataItems.sort((a, b) => sortColor(b, a)); break;
                }
            }
        }

        return (
            <tbody>
                {!loaded && <tr><td>Nalagam...</td></tr>}

                {
                    dataItems.map((item, key) => {

                        let styleDivider = null;
                        if (prej != null && dividerOn != null) {

                            if (prej[dividerOn] != item[dividerOn]) {
                                styleDivider = true;
                            }
                        }
                        prej = item;

                        if (styleDivider == null) {
                            return (
                                <tr
                                    ref={(selectedItem && selectedItem[mainKey] == item[mainKey]) ? scrollDiv : null}
                                    key={item[mainKey]}
                                    onClick={() => onSelectionChanged(item)}
                                    className={selectedItem && selectedItem[mainKey] == item[mainKey] ? "rowSelected" : ""}
                                >
                                    {
                                        renderItem(item)
                                    }
                                </tr>

                            )
                        } else {
                            return (
                                <Fragment>
                                    <tr key={item[mainKey] + "_" + key}><td colSpan={columns.length} style={{ padding: "0px" }}><div style={{ width: "100%", height: "2px", backgroundColor: "rgb(90, 156, 213)" }}></div></td></tr>

                                    <tr
                                        ref={(selectedItem && selectedItem[mainKey] == item[mainKey]) ? scrollDiv : null}
                                        key={item[mainKey]}
                                        onClick={() => onSelectionChanged(item)}
                                        className={selectedItem && selectedItem[mainKey] == item[mainKey] ? "rowSelected" : ""}
                                    >

                                        {
                                            renderItem(item)
                                        }
                                    </tr>
                                </Fragment>
                            )
                        }
                    })}

            </tbody>
        );
    };
    var prej = null;
    const renderItem = (item) => {
        if (dataColumns == null) {
            return null;
        }


        return (

            dataColumns.map((col, key) =>

                <td
                    key={(col.type == "divider" ? "divider" : col.key) + "-" + key + "-" + col[mainKey]}
                    style={{
                        ...(col.type == "checkBox" ? { textAlign: "center" } : {}),
                        ...(col.align != null ? { textAlign: col.align } : {}),
                        ...(col.cellStyle != undefined ? col.cellStyle.style : {}),
                        ...(col.cellStyleFun != undefined ? col.cellStyleFun(item) : {})
                    }}
                    className={
                        (((col.editable && selectedItem && selectedItem[mainKey] === item[mainKey] && (col.isEditable == undefined || col.isEditable(col, item))) || col.type == "checkBox") ? "biDataGridCellEditable" : "") +
                        ((col.type == "divider") ? " biDataGridDivider" : "") +
                        ((col.type == "button") ? " biDataGridCellEditable" : "")
                    }
                >
                    {renderValue(item, col)}
                </td>
            )
        )
    }

    const renderValue = (item, col) => {
        var dis = false;
        if (col.disabled != null) {
            dis = col.disabled(item);
        }

        if (dis) {
            return "";
        }

        var edit = col.editable == true;
        if (col.isEditable != undefined) {
            edit = col.isEditable(col, item);
        }

        if (edit && selectedItem && selectedItem[mainKey] === item[mainKey]) {
            if (col.type == "decimal") {
                return renderDecimalEditable(col, item[col.key]);
            }
            else if (col.type == "string") {
                return renderStringEditable(col, item[col.key]);
            }
            else if (col.type == "color") {
                return renderColorEditable(col, item[col.key]);
            }
            else if (col.type == "checkBox") {
                return renderBoolEditable(col, item[col.key], item);
            }
            else if (col.type == "date") {
                return renderDateEditable(col, item[col.key]);
            }
            else if (col.type == "dateTime") {
                return renderDateTime(item[col.key]);
            }
            else if (col.type == "comboBox") {
                return renderCBEditable(col, item[col.key]);
            }
            else if (col.type == "autoCB") {
                return renderAutoCBEditable(col, item[col.key]);
            }
            else if (col.type == "time") {
                return renderTimeEditable(col, item[col.key]);
            }
            else if (col.type == "timeDT") {
                return renderTimeDTEditable(col, item[col.key]);
            }
            else if (col.type == "button") {
                return renderButton(col, item);
            }
            else if (col.type == "template") {

                if (col.editFunction != null) {

                    return col.editFunction(col, item);
                }
                return ""
            }

        } else {
            if (col.type == "decimal") {
                return renderDecimal(col, item[col.key]);
            }
            else if (col.type == "string") {
                return renderString(item[col.key]);
            }
            else if (col.type == "color") {
                return renderColor(item[col.key]);
            }
            else if (col.type == "date") {
                return renderDate(item[col.key]);
            }
            else if (col.type == "dateTime") {
                return renderDateTime(item[col.key]);
            }
            else if (col.type == "time") {
                return renderTime(item[col.key]);
            }
            else if (col.type == "timeDT") {
                return renderTimeDT(col, item[col.key]);
            }
            else if (col.type == "checkBox") {
                return renderBoolEditable(col, item[col.key], item);
            }
            else if (col.type == "comboBox") {
                return renderCB(item[col.key]);
            }
            else if (col.type == "autoCB") {
                return renderAutoCB(item[col.key]);
            }
            else if (col.type == "divider") {
                return renderDivider();
            }
            else if (col.type == "button") {
                return renderButton(col, item);
            }
            else if (col.type == "template") {
                if (col.displayFunction != null) {
                    return col.displayFunction(col, item);
                }
                return ""
            }
        }
    }
    const renderColor = (value) => {
        if (value != null) {
            let bar = value;
            if (bar.length > 7) {
                bar = bar.replace("#FF", "#");
            }

            return <div style={{ backgroundColor: bar, height: "20px", width: "100%", textAlign: "center" }}></div>;
        } else {
            return "";
        }
    }
    const renderColorEditable = (col, value) => {
        return <BiColorPicker value={value} onChange={onSelectedItemChanged} name={col.key}></BiColorPicker>
    }
    const renderBool = (value) => {
        return value ? <i className="fas fa-check"></i> : "";
    }
    const renderBoolEditable = (col, value, item) => {
        return <div style={{ margin: "3px" }}><BiCheckBox style="0" selected={value} onChange={(e) => onSelectedItemChangedCB(e, item)} onClick={() => onSelectionChanged(item)} name={col.key} disabled={disabled} ></BiCheckBox></div>;
    }
    const renderDecimal = (col, value) => {
        if (value == null)
            return "";
        let frm = "0.[00]";
        if (col.format != null) {
            frm = col.format;
        }
        var num = numeral(value);

        return wrapLabel(num.format(frm));
    }
    const renderDecimalEditable = (col, value) => {
        return <BiTextBox readOnly={readOnly} align={col.align} value={value} onChange={onSelectedItemChanged} name={col.key} numeric={true} format={col.format}></BiTextBox>;
    }
    const renderCB = (value) => {
        if (value == null)
            return "";
        return wrapLabel(value.naziv);
    }
    const renderCBEditable = (col, value) => {
        return <BiComboBox readOnly={readOnly} item={value} items={col.items.items} onItemSelected={onSelectedItemChanged} name={col.key}></BiComboBox>;
    }

    const renderAutoCB = (value) => {
        if (value == null)
            return "";
        return wrapLabel(value.naziv);
    }
    const renderAutoCBEditable = (col, value) => {

        return <BiAutoCB
            readOnly={readOnly}
            online={col.online.online}
            onlineID={col.onlineID}
            items={col.items != null ? col.items.items : null}
            placeholder="--"
            onItemSelected={onSelectedItemChanged}
            name={col.key}
            item={value}
        >
        </BiAutoCB>

    }

    const renderString = (value) => {
        return wrapLabel(value);
    }
    const renderStringEditable = (col, value) => {
        return <BiTextBox readOnly={readOnly} value={value} onChange={onSelectedItemChanged} name={col.key} ></BiTextBox>;
    }
    const renderDate = (value) => {
        if (value == null) return null;
        return wrapLabel(format(new Date(value), "dd.MM.yyyy"));
    }
    const renderDateTime = (value) => {
        if (value == null) return null;
        return wrapLabel(format(new Date(value), "dd.MM.yyyy HH:mm:ss"));
    }
    const renderTimeDT = (col, value) => {

        if (value == null) return null;
        let val = value;
        if (val.length < 10) {
            val = format(new Date(), "yyyy-MM-dd") + val;
        }
        try {
            return wrapLabel(format(new Date(val), col.format != null ? col.format : "H:mm:ss"));
        } catch {
            return wrapLabel("");
        }
    }
    const renderDateEditable = (col, value) => {
        return <BiDatePicker readOnly={readOnly} name={col.key} value={value} width={col.width} onChange={onSelectedItemChanged} minDate={col.minDate} ></BiDatePicker>;
    }
    const renderTimeEditable = (col, value) => {
        return <BiTimePicker readOnly={readOnly} format={col.format} name={col.key} value={value} width={col.width} onChange={onSelectedItemChanged}></BiTimePicker>;
    }
    const renderTimeDTEditable = (col, value) => {
        return <BiTimeDTPicker readOnly={readOnly} format={col.format} name={col.key} value={value} width={col.width} onChange={onSelectedItemChanged}></BiTimeDTPicker>;
    }
    const renderTime = (value) => {
        if (value == null || value == 0) return null;
        return wrapLabel(Sec2Str(value));
    }
    const renderButton = (col, item) => {

        return <BiButton className={col.className} width={col.width} onClick={() => col.onClick(item)}>{col.text}</BiButton>
    }
    const renderDivider = () => {
        return null;
    }

    const wrapLabel = (value) => {



        return <div className="biDataGridLabel">{value}</div>;
    }


    const keydownHandler = (e) => {
        var index = dataItems.findIndex(it => it[mainKey] === selectedItem[mainKey]);
        if (e.keyCode === 40) {
            if (index < dataItems.length - 1) {
                onSelectionChanged(dataItems[index + 1]);
            }
            if (scrollDiv != null && scrollDiv.current != null) {
                scrollDiv.current.scrollIntoView({ block: 'center' });
            }
            e.preventDefault();
        }
        if (e.keyCode === 38) {
            if (index > 0) {
                onSelectionChanged(dataItems[index - 1]);
            }
            if (scrollDiv != null && scrollDiv.current != null) {
                scrollDiv.current.scrollIntoView({ block: 'center' });
            }
            e.preventDefault();
        }

    }

    var st = {
        marginTop: (addUrl != null || removeUrl != null || toolbar != null) ? "2px" : "0px",
        marginBottom: (addUrl != null || removeUrl != null || toolbar != null) ? "4px" : "0px",
        display: "flex"

    }
    var st1 = {
        height: (addUrl != null || removeUrl != null || toolbar != null) ? "calc(100% - 34px)" : "100%",
        minHeight: "inherit"
    }
    let he = 0;
    if ((addUrl != null || removeUrl != null || toolbar != null)) {
        he += 34;
    }
    if (footer != null) {
        he += 25;
    }
    st1.height = "calc(100% - " + he + "px)"

    return (
        <Fragment>
            <div style={st}>
                {!(disabled == true) &&
                    <Fragment>

                        {addUrl &&
                            <BiButton disabled={dataItems == null} className="btn-outline-secondary" icon="fas fa-plus-circle" onClick={() => addClick()}>Dodaj</BiButton>
                        }
                        {removeUrl &&
                            <BiButton disabled={dataItems == null} className="btn-outline-secondary" margin="0px 5px" icon="fas fa-trash-alt" onClick={() => removeClick()}>Briši</BiButton>
                        }
                    </Fragment>
                }
                {toolbar}
            </div>
            <div className="table-responsive biDataGridCont" style={st1} >
                <table cellSpacing="0" className="table biDataGrid table-fixed table-sm table-hover table-striped" onKeyDown={keydownHandler} tabIndex={-1}>

                    {renderColDef()}

                    {renderHeader()}

                    {renderItems()}


                </table>
            </div>
            {footer &&
                <div className="biDataGridFooter">{footer}</div>
            }
        </Fragment>
    );
}

export default BiDataGrid;